const Juridoc = () => {
  return (
    <span className="svg-icon">
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="17.408" height="15.905" viewBox="0 0 17.408 15.905">
        <defs>
          <clipPath id="clip-path">
            <path id="Tracé_7" data-name="Tracé 7" d="M100.044-81.293A1.568,1.568,0,0,1,101.685-83a1.567,1.567,0,0,1,1.629,1.719L103.272-68.8a1.567,1.567,0,0,1-1.64,1.706A1.57,1.57,0,0,1,100-68.813Z" transform="translate(-100 83)" fill="none"/>
          </clipPath>
          <clipPath id="clip-path-2">
            <path id="Tracé_6" data-name="Tracé 6" d="M-154,21.664H138.028V-186H-154Z" transform="translate(154 186)" fill="none"/>
          </clipPath>
          <clipPath id="clip-path-3">
            <path id="Tracé_37" data-name="Tracé 37" d="M21.248-74.462l-9.964,7.141a.811.811,0,0,1-.843.062A.811.811,0,0,1,10-67.98V-82.263a.811.811,0,0,1,.811-.811.811.811,0,0,1,.473.152l9.964,7.141a.811.811,0,0,1,.187,1.132A.812.812,0,0,1,21.248-74.462Z" transform="translate(-10 83.074)" fill="none"/>
          </clipPath>
        </defs>
        <g id="Composant_3_1" data-name="Composant 3 – 1" transform="translate(0 0)">
          <g id="Groupe_5" data-name="Groupe 5" transform="translate(0 0)" clipPath="url(#clip-path)">
            <g id="Groupe_4" data-name="Groupe 4" transform="translate(-51.511 -20.888)" clipPath="url(#clip-path-2)">
              <path id="Tracé_5" data-name="Tracé 5" d="M95-88h5.341v17.931H95Z" transform="translate(-44.503 107.874)" fill="#1e548a"/>
            </g>
          </g>
          <g id="Groupe_25" data-name="Groupe 25" transform="translate(5.821 0)" clipPath="url(#clip-path-3)">
            <g id="Groupe_24" data-name="Groupe 24" transform="translate(-33.259 -20.873)" clipPath="url(#clip-path-2)">
              <path id="Tracé_35" data-name="Tracé 35" d="M18.614-88.07v17.932H5V-88.07Z" transform="translate(27.245 107.93)" fill="#61e786"/>
            </g>
          </g>
        </g>
      </svg>
    </span>
  )
}

export default Juridoc